var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("Add details")])]), _c('a-row', [_c('a-col', {
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 12
      }
    }
  }, [_c('a-form-model', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('a-form-model-item', {
    ref: "name",
    attrs: {
      "prop": "name",
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Name"
    },
    on: {
      "blur": function blur() {
        _vm.$refs.name.onFieldBlur();
      }
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c('a-form-model-item', {
    ref: "reportEmails",
    attrs: {
      "prop": "reportEmails",
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Report emails",
      "help": "Delimit with ';'"
    },
    on: {
      "blur": function blur() {
        _vm.$refs.reportEmails.onFieldBlur();
      }
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.reportEmails,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reportEmails", $$v);
      },
      expression: "form.reportEmails"
    }
  })], 1), _c('a-form-model-item', {
    ref: "shortName",
    attrs: {
      "prop": "shortName",
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Short name"
    },
    on: {
      "blur": function blur() {
        _vm.$refs.shortName.onFieldBlur();
      }
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.shortName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "shortName", $$v);
      },
      expression: "form.shortName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Phone"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Address line 1"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.addressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "addressLine1", $$v);
      },
      expression: "form.addressLine1"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Address line 2"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.addressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "addressLine2", $$v);
      },
      expression: "form.addressLine2"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "ZIP code"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.zipCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "zipCode", $$v);
      },
      expression: "form.zipCode"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "City"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.city,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "city", $$v);
      },
      expression: "form.city"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Country"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.country,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "country", $$v);
      },
      expression: "form.country"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "VAT code"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.vatCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vatCode", $$v);
      },
      expression: "form.vatCode"
    }
  })], 1), _c('a-form-model-item', {
    ref: "collateral",
    attrs: {
      "prop": "collateral",
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Collateral"
    }
  }, [_c('a-input-number', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: _vm.form.collateral,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "collateral", $$v);
      },
      expression: "form.collateral"
    }
  }), _vm._v(" EUR ")], 1), _c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("Assign users")])]), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Users"
    }
  }, [_c('a-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "mode": "multiple",
      "show-search": "",
      "option-filter-prop": "children",
      "allowClear": "",
      "placeholder": "Select users to assign",
      "filter-option": _vm.filterOption
    },
    model: {
      value: _vm.form.users,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "users", $$v);
      },
      expression: "form.users"
    }
  }, _vm._l(_vm.availableUsers, function (user) {
    return _c('a-select-option', {
      key: user.id,
      attrs: {
        "value": user.id
      }
    }, [_vm._v(_vm._s(user.name))]);
  }), 1)], 1), _c('a-button', {
    staticClass: "btn btn-success float-right",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Save ")])], 1)], 1)], 1)], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }